
import {
  Card,
  CardHeader,
  CardBody,

  Row,
  Col,
} from "reactstrap";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import DocViewer, { PDFRenderer } from "react-doc-viewer";
import React from "react";




function User() {



    var docs = [
     
      { uri: require("./V3.pdf") }, // Local File

    ];
  
    return (
      <>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                </CardHeader>
                <CardBody>
                <DocViewer documents={docs} pluginRenderers={[PDFRenderer]}

config={{
 header: {
  disableHeader: false,
  disableFileName: true,
  retainURLParams: false
 }
}}


 />
                </CardBody>
                </Card>

            </Col>
          </Row>
        </div>
      </>
    );
  }







export default User;
